'use strict';
const {
    trackClickEvent,
    trackJQElementDisplayed,
} = require('od-modules/track_events/track.frontevents.utils');

const downloadAppBannerFactory = require('../../../app_download/download_app_banner/js/main');

const {BIM_CANCELLATION_TYPE, BIM_TYPE} = require('../../incidents_manager/js/utils/constants');
const trackingUtils = require('od-modules/utils/tracking.utils');
const myTripsUtils = require('od-modules/utils/my_trips.utils');
const bookingDetailUtils = require('./utils/booking_detail_utils');
const logger = require('od-modules/utils/logger');
const touchpoints = require('od-modules/xsell/config/touchpoints_names');
const tripDetailsStorageUtils = require('od-modules/utils/tripdetails_storage.utils');
const {
    TRACKING,
    CSS_CLASSES,
    INDEX_TRIP_DETAIL,
    BOOKING_INFO_KEY,
    DEFAULT_TAB_CONTROLLER,
    BOOKING_STATUS_TRACKING_MAP,
    MEMBERSHIP_HOTEL_BANNER,
    getTripsActiveClass,
    getArrivalCity,
    trackShowHotelClick,
    trackWidgetOnLoad,
    isPrimeConditionsHotel,
    replaceSoTitleNames,
    isManageBookingAvailable,
    getIndexOfPendingOrConfirmedWithItineraryBooking,
    get$ElementsInElement,
    getTransportType,
    hasSameContentKeyword,
    trackEvent,
    generateProductOrder,
    setPageScroll,
    trackMMBClickButton,
    getBookingInfo,
    getBookingId,
    getMappingList,
    removeFakeAddressInfo,
    trackPageByBookingType,
    shouldRenderCheckinTab,
    getContentKeyword,
    getServiceOptionToDisplay,
    getComponentFBM,
    trackTripdetailsDisplayed,
    getTrackingElementId,
    getProductNameByBookingData,
    shouldRenderCheckinTabTrainRevamp,
    getDealsPillHotelsTabText,
} = require('./utils/constants');
const appTouchPointFactory = require('components/app_download/app_touchpoint/js/main');
const bagsAndSeatsOfflineFactory = require('components/bags_and_seats/bags_and_seats_offline/js/main');
const ancillariesFactory = require('components/bags_and_seats/ancillaries/js/main');
const baggagePostBookingFactory = require('components/bags_and_seats/baggage/baggage_wrapper_postbooking/js/main');
const seatsPostBookingFactory = require('components/bags_and_seats/seats/seats_wrapper_postbooking/js/main');
const boardingOptionsPostBookingFactory = require('components/bags_and_seats/boarding_options/boarding_options_wrapper_postbooking/js/main');
const incidentsManagerFactory = require('components/user_area/incidents_manager/js/main');
const bookingItineraryFactory = require('components/user_area/booking_itinerary/js/main');
const intermediateLayerManager = require('components/user_area/intermediate_layer_manager/js/main');
const notificationsManagerFactory = require('components/user_area/notifications_manager/js/main');
const discountBubbleFactory = require('components/user_area/discount_bubble/js/main');
const discountBubbleFactoryMembership = require('components/user_area/discount_bubble_membership/js/main');
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const withCachedSelectors = require('components-framework/view/with_cached_selectors');
const isRedirectionFromConfirmation = require('od-modules/xsell/utils').isRedirectionFromConfirmation;
const MMBButton = require('components/mmb_button/js/main');
const bookingInfoModel = require('components/user_area/booking_info');
const {preloadMmb, preloadMmbBase} = require('components/user_area/booking_info/mmb.preload');
const conchitaFactory = require('components/conchita/js/main');
const createWidgetLoader = require('components-framework/widget/create_widget_loader');
const manageMyBookingModule = require('od-modules/manage_my_booking/manage_my_booking');
const websiteConfigCollection = require('od-modules/collections/website.collection').getInstance();
const {default: membershipHotelBanner} = require('components/user_area/membership_hotel_banner/js/main');
const membershipRepository = require('od-modules/xsell/repositories/membership_repository');
const DownloadAppNotification = require('components/user_area/download_app_notification/js/main');
const pbAncillariesCollection = require('od-modules/collections/pb_ancillaries_collection/collection');
const moduleXSELLController = import(/* webpackChunkName: "module-xsell" */ 'od-modules/xsell/controller');
const checkinModule = import(/* webpackChunkName: "module-checkin" */ 'od-modules/checkin');
const tagManagement = require('od-modules/utils/tag_management.utils');
const {openChat, closeChat, sendResume, initChat} = require('od-modules/chat/chat_script');
const getFrontendBookingManagement = () => import('@edreamsodigeo/frontend-booking-management');
const {trackDOMElementDisplayed} = require('od-modules/track_events/track.frontevents.utils');

module.exports = withRenderedMain(withCachedSelectors(BaseView.extend({
    templateSettings: {
        evaluate: /\{\{#([\s\S]+?)\}\}/g,
        interpolate: /\{\{[^#{]([\s\S]+?)[^}]\}\}/g,
        escape: /\{\{\{([\s\S]+?)\}\}\}/g,
    },

    selectors: {
        goHome: '.go_home',
        findBookings: '.find_bookings',
        findBookingHotels: '.find_booking_hotels',
        findBookingCars: '.find_booking_cars',
        myTripsBody: '.my_trips_body',
        myTripsWithBookings: '.my_trips_with_bookings',
        myTripsWithPastBookings: '.my_trips_with_past_bookings',
        myTripsBookingDetails: '.my_trips_booking_details',
        tripDetailsPage: '#tripdetails_page',
        tripDetailsDisplayContainer: '#my_trips_booking_details_display_container',
        intermediateLayer: '.intermediate_layer',
        myTripsWaiting: '.mytrips_waiting',
        myTripsListNav: '.my_trips_list_nav',
        myTripsListNavTab: '.trips_list_tab',
        myTripsUpcomingTab: '.trips_list_tab[data-tripstab="upcoming"]',
        myTripsPastTab: '.trips_list_tab[data-tripstab="past"]',
        myTripsUpcomingTitle: '.my_trips_upcoming_title',
        deepTokenKoLightbox: '.deep_token_ko_lightbox',
        deepTokenNotOwnerLightbox: '.deep_token_not_owner_lightbox',
        /* Tripdetails events */
        tabSelectorsContainer: '.smt_tabs_selector_container',
        tabsContentWrapper: '.smt_tabs_content_wrapper',
        tripCardCheckInButton: '.trip_card_check_in_button',
        checkinPillRequest: '.checkin_pill_request',
        hotelWidget: '.hotel_widget_wrapper',
        hotelDiscountBubble: '.hotel_discount_bubble',
        manageMyBookingContainer: '.manage_my_booking_box',
        newManageMyBookingLightbox: '.new_manage_my_booking_lightbox',
        cancellationHSALightbox: '.cancellation_hsa_lightbox',
        alternativesLightbox: '.alternatives_lightbox',
        modifyTripLightbox: '.modify_trip_lightbox',
        flightStatusMessage: '.flight_status_message',
        downloadAppNotification: '.download_app_notification_lightbox',
        tripStatusCard: '.trip_status_card',
        segmentsItineraryBox: '.segments_itinerary_box',
        checkinTabBadge: '.checkin_tab_badge',
        legacyPostBookingSeatsWrapper: '.seats_postbooking',
        postBookingSeatsWrapper: '#post_booking_seats',
    },

    events: {
        'tap .one_trip_card': '_goToTappedOneTrip',
        'tap .one_trip_button': '_goToTappedOneTrip',
        'tap .link_box_item': '_goToLink',
        'tap .folded_clickable': '_foldingDetails',
        'tap .pax_details_open_add_bags': 'openBagsPopup',
        'tap .pax_details_open_choose_seats': 'openSeatsPopup',
        'tap .lightbox_wrapper': 'closeLightBox',
        'tap .lightbox_close': 'closeLightBox',
        /* Tripdetails events */
        'tap .smt_tab_selector': 'tabSelection',
        'tap .manage_my_booking_list_btn': 'onManageMyBookingListBtn',
        'tap .goToMmbPage': 'onClickToMmbBtn',
        'tap .trips_list_tab': 'onTapTripsListTab',
        'tap .membership_show_hotels': 'onShowHotels',
        'tap .download_app_notification_lightbox_close': 'toggleDownloadAppNotificationLightbox',
    },
    components: {
        incidents: null,
        bookingItinerary: null,
        appTouchPoint: null,
        intermediateLayer: null,
        notifications: null,
        hotelDiscountBubble: null,
        bagsAndSeatsOffline: null,
        baggagePostBooking: null,
        seatsPostBooking: null,
        boardingOptionsPostBooking: null,
        confirmationBenefits: null,
        membershipHotelBanner: null,
    },
    trackingCategory: null,
    manageBookingWindow: null,
    widgetLoader: null,
    loadTripDetail: false,
    updatedAccommodationCancellation: false,
    userDTO: {},

    initialize() {
        this.bindToDom();
        this.toggleWaitingPageVisibility(true);
        this.createAppTouchPoint(this.$el, 'mytripswithoutbookings', 'my_area_no_trips');
        this.tabsController = Odigeo._.mapValues(Odigeo._.invert(this.model.TAB_CONTENT_KEYWORDS), Odigeo._.constant(DEFAULT_TAB_CONTROLLER));
        if (!Odigeo.AB.isSplitMMBFromTripdetails) {
            this.widgetLoader = createWidgetLoader({
                conchita: ['conchita', conchitaFactory],
            });
        }
    },

    configureMMBRouterEvents(bookId, bookMail, page) {
        Odigeo.Router.eventController = $.extend(true, Odigeo.Router.eventController,
            {
                globalEvents: {},
                viewEvents: {
                    'conchita:MMB:reloadTripDetails': 'onReloadTripDetails',
                    'conchita:OpenTicket:Confirmation:goToTripDetails': 'onLightboxClose',
                    'conchita:MMB:VoluntaryCancellation:bookingUpdated': 'onBookingUpdatedCancellation',
                    'conchita:MMB:VoluntaryModification:bookingUpdated': 'onBookingUpdatedModification',
                    'conchita:MMB:Accommodation:VoluntaryCancellation:bookingUpdated': 'onBookingAccommodationUpdated',
                    'conchita:MMB:Accommodation:Confirmation:goToHome': 'onNavigateToHome',
                    'conchita:MMB:MainMenu:Close': 'onLightboxClose',
                    'conchita:MMB:MainMenu:goToPostBookingPrime': 'onMainMenuGoToPostBookingPrime',
                    'conchita:MMB:InnerMenu:AdditionalServices:gotToProducts': 'onGoToProducts',
                    'conchita:MMB:InnerMenu:AdditionalServices:goToCar': 'onInnerMenuAdditionalServicesGoToCar',
                    'conchita:MMB:InnerMenu:AdditionalServices:goToHotel': 'onInnerMenuAdditionalServicesGoToHotel',
                    'conchita:MMB:InnerMenu:AdditionalServices:goToTransfer': 'onInnerMenuAdditionalServicesGoToTransfer',
                    'conchita:MMB:InnerMenu:AdditionalServices:goToActivities': 'onInnerMenuAdditionalServicesGoToActivities',
                    'conchita:MMB:AlternativesFlight:reloadNotification': 'onBookingUpdatedCancellation',
                    'conchita:MMB:CustomerSupport': 'onNavigateToCustomerSupport',
                    'conchita:MMB:CancellationFlightSelector': 'onNavigateToCancellationFlightSelector',
                    'conchita:MMB:ModificationOF2': 'onNavigateToModificationOF2',
                    'conchita:MMB:ModificationStatusOF2': 'onNavigateToModificationStatusOF2',
                    'conchita:MMB:NameChangeOF2': 'onNavigateToNameChangeOF2',
                    'conchita:MMB:CancellationOF2': 'onNavigateToCancellationOF2',
                    'conchita:MMB:ManagePreferredDatesOF2': 'onManagePreferredDatesOF2',
                    'conchita:MMB:CancelForAnyReasonOF2': 'onNavigateToCancelForAnyReasonOF2',
                    'conchita:MMB:CancellationSummaryLCC': 'onNavigateToCancellationSummaryLCC',
                    'conchita:MMB:CancellationFlightSelectorLCC': 'onNavigateToCancellationFlightSelectorLCC',
                    'conchita:MMB:CancellationStopoverSelectorLCC': 'onNavigateToCancellationStopoverSelectorLCC',
                    'conchita:PBC:goToPrimeFreeCancellationOF2': 'onNavigatePrimeFreeCancellationOF2',
                    'conchita:MMB:goToAlternativesFlow': 'onNavigateToAlternativesFlow',
                    'conchita:MMB:goToAlternativesFlowOF2': 'onNavigateToAlternativesFlowOF2',
                    'conchita:MMB:ModificationSummaryLC': 'onNavigateToModificationSummaryLC',
                    'conchita:MMB:ModificationFlightSelectorLC': 'onNavigateToModificationFlightSelectorLC',
                    'conchita:MMB:ModificationStopoverSelectorLC': 'onNavigateToModificationStopoverSelectorLC',
                    'conchita:MMB:LaunchComponentDisplayed': 'onLaunchComponentDisplayed',
                },
                eventHandlers: {
                    onLaunchComponentDisplayed: () => {
                        trackDOMElementDisplayed($('#prime-acquisition-button')[0]);
                    },
                    onReloadTripDetails: () => {
                        Odigeo.Router.navigate('tripdetails');
                        location.reload();
                    },
                    onBookingUpdatedCancellation: () => {
                        this.refreshNotifications();
                    },
                    onBookingUpdatedModification: () => {
                        this.loadNotifications(Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')), true);
                    },
                    onBookingAccommodationUpdated: () => {
                        this.updatedAccommodationCancellation = true;
                    },
                    onNavigateToHome: () => {
                        this.toggleMMBLightbox(page);
                        location.href = location.protocol + '//' + location.hostname;
                    },
                    onNavigateToCustomerSupport: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`categories/${tdToken}`);
                    },
                    onNavigateToCancellationFlightSelector: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxflightselector/${tdToken}`);
                    },
                    onNavigateToModificationOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modify_flightselector/${tdToken}`);
                    },
                    onNavigateToModificationStatusOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modify_status/${tdToken}`);
                    },
                    onNavigateToNameChangeOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modify_changename_info/${tdToken}`);
                    },
                    onManagePreferredDatesOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modify_preferred_dates/${tdToken}`);
                    },
                    onNavigateToCancellationOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxsummary/${tdToken}`);
                    },
                    onNavigateToCancelForAnyReasonOF2: ({lowCost}) => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxinfo/${lowCost ? 'lowcost/' : ''}${tdToken}`);
                    },
                    onNavigateToCancellationSummaryLCC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxlcc_summary/${tdToken}`);
                    },
                    onNavigateToCancellationFlightSelectorLCC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxlcc_flightselector/${tdToken}`);
                    },
                    onNavigateToCancellationStopoverSelectorLCC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`cnxslcc_stopovers/${tdToken}`);
                    },
                    onNavigateToModificationSummaryLC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modifylc_change_trip/${tdToken}`);
                    },
                    onNavigateToModificationFlightSelectorLC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modifylc_your_flights/${tdToken}`);
                    },
                    onNavigateToModificationStopoverSelectorLC: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`modifylc_your_stopovers/${tdToken}`);
                    },
                    onNavigateToAlternativesFlow: () => {
                        this.openNewAlternativesFlow();
                        this.toggleMMBLightbox('modifyTrip');
                    },
                    onNavigatePrimeFreeCancellationOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`booking_cancellation/trip_management/${tdToken}`);
                    },
                    onNavigateToAlternativesFlowOF2: () => {
                        const {tdToken} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')) || {};
                        Odigeo.Router.navigate(`alt_intro/${tdToken}`);
                    },
                    onLightboxClose: () => {
                        this.toggleMMBLightbox(page);
                        if (this.updatedAccommodationCancellation) {
                            this.updatedAccommodationCancellation = false;
                            location.reload();
                        } else {
                            const getPageDetail = this.model.get('pageDetail');
                            trackingUtils.trackPage(getPageDetail, {
                                funnel: false,
                            });
                        }
                    },
                    onGoToProducts: ({payload}) => {
                        this.toggleMMBLightbox(page);
                        if (Odigeo.History.getPageNameFromFragment() === 'tripdetails') {
                            this.makeProductTabVisible('offersAndDiscounts');
                            this.scrollToProduct(payload);
                        } else {
                            Odigeo.Router.navigate('tripdetails', {params: `showProduct=true;product=${payload}`});
                        }
                    },
                    onMainMenuGoToPostBookingPrime: () => manageMyBookingModule.navigateOutside('primepostbooking'),
                    onInnerMenuAdditionalServicesGoToCar: () => manageMyBookingModule.openDeepLinkByProduct('car', bookId, bookMail),
                    onInnerMenuAdditionalServicesGoToHotel: () => manageMyBookingModule.openDeepLinkByProduct(
                        'hotel',
                        bookId,
                        bookMail,
                        touchpoints.mytripsdetails_hotels_itinerary_textlink,
                    ),
                    onInnerMenuAdditionalServicesGoToTransfer: () => manageMyBookingModule.openDeepLinkByProduct('transfer', bookId, bookMail),
                    onInnerMenuAdditionalServicesGoToActivities: () => manageMyBookingModule.openDeepLinkByProduct('activities', bookId, bookMail),
                },
            });
        Odigeo.Router.eventController.execute();
    },

    async scrollToProduct(product) {
        const selectorByProduct = {
            bags: '.baggage_postbooking',
            seats: '.seats_postbooking',
        };
        const loadingElement = '.ancillaries_box_container .odf-box:not(.odf-loading-waves)';
        const selector = selectorByProduct[product];
        const productElement = await new Promise((resolve) => {
            if (this.$el.find(`${selector} ${loadingElement}`)[0]) {
                return resolve(this.$el.find(selector));
            }
            const observer = new MutationObserver(() => {
                if (this.$el.find(`${selector} ${loadingElement}`)[0]) {
                    observer.disconnect();
                    resolve(this.$el.find(selector));
                }
            });
            observer.observe(this.$el && this.$el[0], {
                childList: true,
                subtree: true,
            });
        });
        Odigeo.Utils.scrollToElement(productElement);
    },

    setPageDetail() {
        const bookingInfo = getBookingInfo();
        const bookingData = bookingInfo.data.userDTO.bookingDetail[INDEX_TRIP_DETAIL];
        const trackTripDetailsPage = `tripdetails/${getProductNameByBookingData(bookingData)}`;
        const pageDetail = Odigeo.History.getPageNameFromFragment() === 'tripdetails' ?
            trackTripDetailsPage :
            Odigeo.History.getPageNameFromFragment();
        this.model.set('pageDetail', pageDetail);
        return pageDetail;
    },

    loadMMB(bookingId, bookingMail, page) {
        const bookingInfo = manageMyBookingModule.getBookingInfo(bookingId, bookingMail);
        this.configureMMBRouterEvents(bookingId, bookingMail, page);
        preloadMmbBase();
        websiteConfigCollection.getLoadedPromise().then(() => {
            getFrontendBookingManagement().then((bookingManagement) => {
                this.widgetLoader.get('conchita')
                    .execute('load', {
                        identifier: `conchita-manage-my-booking${page ? ('-' + page) : ''}`,
                        container: `conchita-manage-my-booking${page ? ('-' + page) : ''}`,
                        component: bookingManagement[getComponentFBM(bookingInfo.isHSABooking, page)],
                        translationPath: '/secure/translations/mmb',
                        data: {
                            bookingInfo,
                            isFirstPage: true,
                            withoutRedirect: true,
                            formatDate: Odigeo.Utils.formatDate,
                            openChat: openChat,
                            closeChat: closeChat,
                            sendResume: sendResume,
                            services: {
                                manageMyBooking: Odigeo.Settings.getProperty('manageMyBookingServiceUrlFormatter'),
                                bookingChangeRequest: Odigeo.Settings.getProperty('bookingChangeRequestServiceUrlFormatter'),
                                collectionMethod: Odigeo.Settings.getProperty('collectionMethodServiceUrlFormatter'),
                                modificationCheckout: Odigeo.Settings.getProperty('modificationCheckoutServiceUrlFormatter'),
                                bookingApi: Odigeo.Settings.getProperty('bookingApiServiceUrlFormatter'),
                                flightIncident: Odigeo.Settings.getProperty('flightIncidentServiceFBMUrlFormatter'),
                                unchainedMembershipPostbooking: Odigeo.Settings.getProperty('unchainedMembershipPostbookingServiceUrlFormatter'),
                            },
                            fireExternalEvent: tagManagement.fireExternalEvent,
                        },
                        conchitaLiveContent: true,
                        module: 'mmb',
                        basePath: window.location.hash.slice(1).split('/').slice(0, 1).join('/'),
                    }).then(initChat());
            });
        });
        this.setPageDetail();
    },

    dispatchSeatMapCheckInAction(...args) {
        this.checkin.execute(...args);
    },

    dispatchProductCheckInAction(...args) {
        this.checkin.execute(...args);
    },

    createAppTouchPoint($container, selector, category, bookingData) {
        const id = `app-touchpoint-${selector}`;
        if ($container.find(`#${id}`).length > 0) {
            this.components.appTouchPoint = appTouchPointFactory.create({
                id,
                options: {
                    selector,
                    trackAction: 'app_banner',
                    trackCategory: category,
                    trackLabel: 'app_download_middle',
                    bookingData,
                },
            });
        }
    },

    getTrackingCategory() {
        return this.trackingCategory;
    },

    setTrackingCategory(category) {
        this.trackingCategory = category;
    },

    bindToDom() {
        this.$cachedSelectors.goHome.off().on(Odigeo.Events.tap, Odigeo._.bind(function() {
            trackEvent('my_area_no_trips', 'no_trips', 'go_home_clicks');
            Odigeo.Utils.goToApplicationHome();
        }, this));
        this.$cachedSelectors.findBookingHotels.off().on(Odigeo.Events.tap, function() {
            // go to URL hotels
        });
        this.$cachedSelectors.findBookingCars.off().on(Odigeo.Events.tap, function() {
            // go to URL cars
        });
        Odigeo.UIElements.hint.enhance(Odigeo.History.getPageNameFromFragment(), this.$cachedSelectors.findBookings, {
            events: {
                tap: true,
            },
        });
    },

    _loadTrips(data, loadTripDetail = false, actions, funnel, autoChange, autoCancel) {
        let {displayName, userDTO: {bookingDetail = [], pastBookingDetail = []}} = data;
        this.updateUserName(displayName);
        this._loadMappings();
        Odigeo.trigger(this.id + ':hideCanFindBooking');
        this.setTrackingCategory(TRACKING.MY_TRIPS_CATEGORY);
        this.model.set('myBookings', data);
        if (loadTripDetail) {
            const extendBookingDetail = bookingDetailUtils.extendBookingDetail(bookingDetail[INDEX_TRIP_DETAIL], this.keys, true);
            this.model.set('bookingTripDetails', extendBookingDetail);
            this.renderTripDetails(extendBookingDetail, actions, funnel, autoChange, autoCancel);
            logger.warn(
                `tripDetailsFinalPrice; bookingId ${extendBookingDetail.bookingBasicInfo.id}; ${extendBookingDetail.formatTotalAmount};`);
            if (Odigeo.Utils.isDesktop() || actions !== 'openmmb' || !extendBookingDetail.itineraryBookings) {
                this.toggleWaitingPageVisibility(false);
            }
        } else {
            bookingDetail = bookingDetail.map((bookingInfo) => bookingDetailUtils.extendBookingDetail(bookingInfo, this.keys, false));
            pastBookingDetail = pastBookingDetail.map((bookingInfo) => bookingDetailUtils.extendBookingDetail(bookingInfo, this.keys, false));
            this.renderMytrips(bookingDetail, pastBookingDetail);
            this.toggleWaitingPageVisibility(false);
        }
    },

    renderMytrips(bookingDetail, pastBookingDetail) {
        const hasUpcomingBookings = bookingDetail.length > 0;
        const hasPastBookings = pastBookingDetail.length > 0;
        if (!hasUpcomingBookings) {
            this.renderNoTrips(hasPastBookings);
        }
        if (hasUpcomingBookings || hasPastBookings) {
            Odigeo.trigger(this.id + ':changeCategoryTracking', TRACKING.MY_TRIPS_CATEGORY);
            this.renderTripList(bookingDetail, pastBookingDetail);
        }
    },

    renderNoTrips(hasPastBookings) {
        this.$cachedSelectors.myTripsBody.attr('data-state', 'noBookings');
        if (!hasPastBookings) {
            const trackNoTrips = {
                action: 'sidebar',
                category: 'my_area_no_trips',
            };
            Odigeo.trigger(this.id + ':dataTrackNoTrips', trackNoTrips);
            Odigeo.trigger(this.id + ':changeCategoryTracking', 'my_area_no_trips');
            Odigeo.trigger(this.id + ':showCanFindBooking', 'my_area_no_trips');
            Odigeo.trigger(this.id + ':showGtBannerNoBookings');
            trackEvent(TRACKING.MY_TRIPS_CATEGORY, 'on_load_events', 'no_trips');
        }
    },

    renderTripList(bookingDetail, pastBookingDetail) {
        const hasUpcomingBookings = bookingDetail.length > 0;
        const hasPastBookings = pastBookingDetail.length > 0;
        const trackingLabel = `${hasUpcomingBookings ? 'upcoming' : 'na'}-${hasPastBookings ? 'past' : 'na'}_trips`;
        if (hasUpcomingBookings) {
            this._loadUpcomingBookingList(bookingDetail);
        }
        if (hasPastBookings) {
            this.updateDomSelectorsToCache();
            this.$cachedSelectors.myTripsUpcomingTitle.addClass('odf-hidden');
            this.$cachedSelectors.myTripsListNav.removeClass('odf-hidden');
            this.$cachedSelectors.myTripsListNavTab.removeClass(getTripsActiveClass());
            this.$cachedSelectors.myTripsUpcomingTab.addClass(getTripsActiveClass());
            this._loadPastBookingList(pastBookingDetail);
            if (!hasUpcomingBookings) {
                this._showTripList('pastListBookings', 'past', this.$cachedSelectors.myTripsPastTab);
            }
        }
        this._loadExternalWidgets();
        trackEvent(TRACKING.MY_TRIPS_CATEGORY, 'on_load_events', trackingLabel);
    },

    _loadExternalWidgets() {
        Odigeo.trigger(this.id + ':showCanFindBooking', TRACKING.MY_TRIPS_CATEGORY);
        Odigeo.trigger(this.id + ':hideManageMyBookingBox');
    },

    renderTripDetails(bookingDetail, actions, page, autoChange, autoCancel) {
        if (bookingDetail.itineraryBookings) {
            if (actions === 'openmmb' && Odigeo.AB.isSplitMMBFromTripdetails) {
                this.navigateToNewMMB(page, autoChange, autoCancel);
            } else {
                this._loadBookingDetails(bookingDetail, actions, page, autoChange, autoCancel);
                Odigeo.trigger(this.id + ':changeCategoryTracking', TRACKING.TRIP_DETAILS_CATEGORY);
            }
        } else {
            this.$cachedSelectors.myTripsBookingDetails.empty();
            this.$cachedSelectors.tripDetailsPage.toggleClass(CSS_CLASSES.ODF_HIDDEN, false);
            if (actions === 'openmmb') {
                this.navigateToNewMMB(page, autoChange, autoCancel);
            }
        }
    },

    loadOpenBookingDetails({product, actions, funnel, autoChange, autoCancel}) {
        const bookingInfo = getBookingInfo();
        this._loadTrips(bookingInfo.data, bookingInfo.loadTripDetail, actions, funnel, autoChange, autoCancel);
        if (Odigeo.Utils.isDesktop()) {
            this.makeProductTabVisible(product, actions);
        }
        if (Odigeo.Utils.isMobile()) {
            this.makeCollapsibleSectionVisible(actions);
        }
    },

    getBookingId() {
        const bookingInfo = this.getBookingInfo();
        const bookingData = bookingInfo.data.userDTO.bookingDetail[INDEX_TRIP_DETAIL];
        return Odigeo._.get(bookingData, 'bookingBasicInfo.id');
    },

    _loadOpenBookingDetails(data) {
        this.$cachedSelectors.tripDetailsPage.toggleClass(CSS_CLASSES.ODF_HIDDEN, true);
        const acceptedOverlayRendered = this.el.querySelector('.open_ticket_accepted_overlay.open.opened');
        if (!data.showFlightCredit || !acceptedOverlayRendered) {
            this.loadOpenBookingDetails(data);
        }
    },

    _bookingListTmplObj(bookingList, tripList) {
        return {
            bookingList,
            tripList,
            translations: this.keys,
            formatDate: Odigeo.Utils.formatDate,
            humanTripDate: Odigeo._.partial(Odigeo.Utils.formatDate, _, _, true), // format date UTC shorthand
            millisecsToDays: Odigeo.Utils.millisecsToDays,
            pluralizeAll: Odigeo.Utils.pluralizeAll,
            replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
            templates: this.templates,
            imagePath: Odigeo.UserArea.imagePath,
        };
    },

    _loadUpcomingBookingList(bookingDetail) {
        this.$cachedSelectors.myTripsBody.attr('data-state', 'listBookings');
        this.$cachedSelectors.myTripsWithBookings.empty()
            .append(this.templates.mytripsBookingList(this._bookingListTmplObj(bookingDetail, 'upcomingTrips')));
        this.createAppTouchPoint(this.$cachedSelectors.myTripsWithBookings, 'mytripswithbookings', TRACKING.MY_TRIPS_CATEGORY,
            bookingDetail && bookingDetail[0]);
        trackJQElementDisplayed(this.$cachedSelectors.myTripsWithBookings.find(
            $(Odigeo.Utils.isDesktop() ? '.manage_my_booking_list_btn' : '.goToMmbPage')[0]));

        const bookingIndex = getIndexOfPendingOrConfirmedWithItineraryBooking(bookingDetail);

        if (bookingIndex > -1) {
            this.$el.find(`.one_trip_container[data-index="${bookingIndex}"] .crossselling_products_container`).append(
                this.templates.mytripsBookingsCrosssell({
                    translations: this.keys,
                    templates: this.templates,
                    bookingDetail: bookingDetail[bookingIndex],
                }));
            moduleXSELLController.then(({default: controller}) => {
                const cont = controller();
                cont.setItinerary(bookingDetail[bookingIndex]);
                cont.setContainer(this.el);
                cont.renderCrosssellPageWidgets();
            });
        }
    },

    _loadPastBookingList(pastBookingDetail) {
        this.$cachedSelectors.myTripsWithPastBookings.empty()
            .append(this.templates.mytripsBookingList(this._bookingListTmplObj(pastBookingDetail, 'pastTrips')));
        this.createAppTouchPoint(this.$cachedSelectors.myTripsWithBookings,
            'mytripswithbookings', TRACKING.MY_TRIPS_CATEGORY, pastBookingDetail && pastBookingDetail[0]);
    },

    _getTripDetailsTemplateToRender(isAutomaticRedirection) {
        if (Odigeo.Utils.isMobile()) {
            return isAutomaticRedirection ?
                this.templates.redirectionMyTripsOneBooking :
                this.templates.myTripsOneBooking;
        } else {
            return this.templates.tripdetailsSmt;
        }
    },

    renderBookingDetails(bookingData, productOrder, isAutomaticRedirection) {
        const serviceOptionToDisplay = getServiceOptionToDisplay(bookingData.postsellServiceOptionBookings || []);

        return Odigeo._.bind(function() {
            let templateData = {
                bookingDetailIndex: INDEX_TRIP_DETAIL,
                bookingDetail: bookingData,
                productOrder: productOrder,
                translations: this.keys,
                templates: this.templates,
                countriesMap: this.model.countries,
                // TODO: pass a utils object (either the whole Odigeo.Utils or an Utils-props-picked obj) instead of all the list below
                formatDate: Odigeo.Utils.formatDate,
                humanTripDate: Odigeo._.partial(Odigeo.Utils.formatDate, _, _, true), // format date UTC shorthand
                pluralizeAll: Odigeo.Utils.pluralizeAll,
                replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
                millisecsToDays: Odigeo.Utils.millisecsToDays,
                stringToProperCase: Odigeo.Utils.stringToProperCase,
                formatMin: Odigeo._.bind(this.formatMin, this),
                hasToReplaceSoTitleNames: replaceSoTitleNames(),
                imagePath: Odigeo.UserArea.imagePath,
                isRedirectionFromConfirmation: isAutomaticRedirection,
                tripType: Odigeo._.get(bookingData, 'itineraryBookings.bookingItinerary.tripType'),
                transportType: Odigeo._.get(bookingData, 'itineraryBookings.bookingItinerary.transportType'),
                serviceOptionToDisplay: serviceOptionToDisplay,
                mmbLink: MMBButton.renderAsLink(),
                mmbButton: MMBButton.renderAsButton(),
                hasToShowMembershipHotelBanner: this.hasToShowMembershipHotelBanner(bookingData),
                downloadAppNotification: DownloadAppNotification.renderTemplate(),
                getDealsPillHotelsTabText: getDealsPillHotelsTabText(bookingData),
                shouldRenderCheckinTab: Odigeo.AB.isTrainDocumentsComponent ?
                    shouldRenderCheckinTabTrainRevamp(bookingData) :
                    shouldRenderCheckinTab(bookingData),
                shouldShowCYJFlightCard: bookingDetailUtils.shouldShowCYJFlightCard(bookingData, this.keys),
                isPositivePrice: bookingData.price.amount > 0,
                trackingElementId: getTrackingElementId(bookingData),
                isPrimeConditionsHotel: isPrimeConditionsHotel(),
                isBuriedCardsExperience: Odigeo.AB.isAlignVoluntaryCancellation &&
                  bookingData.messages && bookingData.messages.some(({cancellationType}) => cancellationType === BIM_CANCELLATION_TYPE.VOLUNTARY),
            };
            const templateToRender = this._getTripDetailsTemplateToRender(isAutomaticRedirection);
            templateData = removeFakeAddressInfo(templateData);
            const $myTripsBookingDetails = this.$cachedSelectors.myTripsBookingDetails.empty()
                .append(templateToRender(templateData));
            this.updateDomSelectorsToCache();
            return $myTripsBookingDetails;
        }, this);
    },

    _loadBookingDetails(bookingData, actions, page, autoChange, autoCancel) {
        const productOrder = Odigeo.Utils.isDesktop() ? generateProductOrder(bookingData) : {};
        const {
            bookingBasicInfo: {id: bookingId},
            buyer: {mail} = {},
            bookingProductStatus =''} = bookingData;
        const isAutomaticRedirection = isRedirectionFromConfirmation(bookingId);
        import('@edreamsodigeo/frontend-tracking-agent').then(({setBookingId}) => setBookingId(bookingId));
        if (!Odigeo.AB.isSplitMMBFromTripdetails) {
            preloadMmb({bookingId, mail});
        }
        this._setTrackingInfo(bookingData);
        const bookingDetails = this.renderBookingDetails(bookingData, productOrder, isAutomaticRedirection);
        const bookingDetailsWrapper = Odigeo._.bind(Odigeo._.wrap(bookingDetails, function(bookingDetailsFunction) {
            if (bookingDetailsFunction().length && this.$cachedSelectors.myTripsBookingDetails.find('.bp_autocheckin_button').length) {
                trackEvent('on_load_events', 'auto_checkin_shown', TRACKING.TRIP_DETAILS_CATEGORY);
            }
        }), this);
        this.$cachedSelectors.myTripsBody.attr('data-state', 'bookingDetails');
        bookingDetailsWrapper(bookingDetails);
        if (!Odigeo.AB.isBookingItinerary) {
            this._createItineraryManager(bookingData);
        }

        if (!Odigeo.AB.isBimTripdetailsNotificationsOf2) {
            this._createNotificationsIfNeeded(bookingData);
            this._createIntermediateLayerManagerIfNeeded(bookingData);
            this._createIncidentManagerIfNeeded(bookingData);
        }

        this.checkIfIsNeedShowAllProducts(bookingData, productOrder, isAutomaticRedirection);
        if (!Odigeo.AB.isSplitMMBFromTripdetails) {
            if (isManageBookingAvailable(bookingData.bookingProductStatus)) {
                this.showManageMyBookingBox(actions === 'openmmb', page, autoChange, autoCancel);
            }
        }
        this.preLoadEpticaHint();
        Odigeo.trigger(this.id + ':my_trips_details_loaded');
        this.bindEpticaLinks();
        trackingUtils.trackEvent('my_trips', 'successfully_arrived_to_my_trips_details');
        this.setTrackingCategory(TRACKING.TRIP_DETAILS_CATEGORY);
        trackTripdetailsDisplayed(this.$cachedSelectors.tripDetailsDisplayContainer && this.$cachedSelectors.tripDetailsDisplayContainer[0]);
        trackPageByBookingType(bookingData, bookingProductStatus, bookingId);
    },

    bindEpticaLinks() {
        Odigeo._.each($(this.$cachedSelectors.myTripsBookingDetails.find('.mytrip_eptica_link')), function(element) {
            $(element).off().on(Odigeo.Events.tap, Odigeo._.bind(function() {
                this._trackEvent(this.TRACKINGS.TRIPDETAILS_CATEGORY, ' trip_details', 'baggage_help_center_clicks');
            }, this));
        }, this);
    },

    preLoadEpticaHint() {
        const epticaHint = this.$cachedSelectors.myTripsBookingDetails.find('.mytrip_eptica_wrapper');
        Odigeo._.each(epticaHint, function(element) {
            Odigeo.UIElements.hint.enhance(
                Odigeo.History.getPageNameFromFragment(), element,
                {
                    generateHtml: true,
                    wrapperClass: 'od-mytrips-hint od-hint-notitle',
                    arrowClass: 'od-hint-arrow-flex',
                    hintTriggerButton: {
                        hintTriggerButtonClass: 'od-mytrips-hint-btn',
                        hintTriggerButtonText: '9',
                    },
                    events: {hover: false, tap: true},
                }
            );
        });
    },
    loadXselingModule({
        controller,
        bookingData,
        el,
        isAutomaticRedirection,
    }) {
        const xsellController = controller();
        xsellController.setItinerary(bookingData);
        xsellController.setContainer(el);
        xsellController.setIsRedirection(isAutomaticRedirection);
        xsellController.renderCrosssellPageWidgets();
    },
    checkIfIsNeedShowAllProducts(bookingData, {bagsAndSeats}, isAutomaticRedirection) {
        if (!bookingData.shouldHideAllProductOffers) {
            this._createBagsAndSeatsIfNeeded(getTransportType(bookingData), bagsAndSeats);
            moduleXSELLController.then(({default: controller}) => {
                if (Odigeo.AB.isBookingItinerary) {
                    this.loadXselingModule({
                        controller,
                        bookingData,
                        el: this.el,
                        isAutomaticRedirection,
                    });
                } else {
                    this.components.bookingItinerary.execute('loadXSELLModule', {
                        controller,
                        bookingData,
                        el: this.el,
                        isAutomaticRedirection,
                    });
                }
            });
            checkinModule.then(({default: checkin}) => {
                this.checkinModule = checkin.factory(bookingData, pbAncillariesCollection, this);
            });
            this.createAppTouchPoint(this.$cachedSelectors.myTripsBookingDetails, 'mytripsdetails', TRACKING.TRIP_DETAILS_CATEGORY, bookingData);
            this._createDiscountBubbleIfNeeded(bookingData);
        }
    },

    _setTrackingInfo({
        itineraryBookings,
        totalPnrsInBooking,
        myTripStatus,
        bookingBasicInfo: {id},
        accommodationBooking,
        travellers,
    }) {
        const totalSections = itineraryBookings.itinerarySegments.map((segment) => segment.sections).flat().length;
        const status = BOOKING_STATUS_TRACKING_MAP[myTripStatus];
        const pax = travellers.length;
        const meta = Odigeo.SessionScope.isMeta ? 1 : 0;
        const type = bookingDetailUtils.getTripTypeAbbr(itineraryBookings);
        const booking = `${totalSections}-${totalPnrsInBooking}`;
        const pag = accommodationBooking !== null ? 'myardp' : 'myarfl';
        this.model.set('trackingInfo', {pag, id, booking, totalSections, totalPnrsInBooking, pax, meta, type, status});
    },

    _createIncidentManagerIfNeeded(bookingData) {
        if (bookingDetailUtils.hasBookingAnyIncident(bookingData) || bookingDetailUtils.hasMessages(bookingData)) {
            this.setIncidentManager(bookingData);
        } else {
            this.showFlightStatusMessage();
        }
    },

    setIncidentManager(bookingData) {
        const trackingInfo = this.model.get('trackingInfo');
        this.components.incidents = incidentsManagerFactory.create({
            el: this.$el.find('.incidents_manager'),
            parentWidget: this,
            bookingData,
            trackingInfo,
        });
    },

    refreshNotifications() {
        if (this.components.incidents) {
            this.components.incidents.execute('persistBIM');
        } else {
            this.setIncidentManager(this.model.get('bookingTripDetails'));
        }
    },

    _createItineraryManager(bookingDetail) {
        const data = {
            bookingDetail: bookingDetail,
            imagePath: Odigeo.UserArea.imagePath,
            tripType: Odigeo._.get(bookingDetail, 'itineraryBookings.bookingItinerary.tripType'),
            trackingInfo: this.model.get('trackingInfo'),
            transportType: Odigeo._.get(bookingDetail, 'itineraryBookings.bookingItinerary.transportType'),
            utils: {
                formatMin: Odigeo._.bind(this.formatMin, this),
                replaceCmsKeyArgs: Odigeo.Utils.replaceCmsKeyArgs,
                stringToProperCase: Odigeo.Utils.stringToProperCase,
                humanTripDate: Odigeo._.partial(Odigeo.Utils.formatDate, _, _, true),
            },
        };

        this.components.bookingItinerary = bookingItineraryFactory.create({
            el: this.$el.find('.itinerary_details'),
            data,
            trackingInfo: this.model.get('trackingInfo'),
        });
    },

    _createIntermediateLayerManagerIfNeeded(bookingData) {
        this.components.intermediateLayer = intermediateLayerManager.create({
            el: this.$cachedSelectors.intermediateLayer,
            parentWidget: this,
            options: {
                bookingID: bookingData.bookingBasicInfo.id,
            },
            trackingInfo: this.model.get('trackingInfo'),
        });
        Odigeo.trigger(this.id + ':intermediateLayerCreated');
    },

    _createDiscountBubbleIfNeeded(bookingData) {
        if (Odigeo.Utils.isDesktop()) {
            const bookingStatus = bookingData.myTripStatus || '';
            const bookingId = bookingData.bookingBasicInfo.id;
            const label = `${bookingStatus.toLowerCase()}_booking_id:${bookingId}`;
            trackEvent(TRACKING.TRIP_DETAILS_CATEGORY, TRACKING.BOOKING_STATUS_ACTION, label);
            if (bookingData.accommodationBooking === null) {
                if (membershipRepository.isPrimeBooking() === false) {
                    this.components.hotelDiscountBubble = this.showDiscountBubble(bookingId);
                }
            }
        }
    },

    _createNotificationsIfNeeded(bookingData) {
        const {messages} = bookingData;
        this.components.notifications = notificationsManagerFactory.create({
            el: this.$el.find('.notifications_manager'),
        });
        if (Odigeo.AB.isBookingImportantMessage && messages && messages.length) {
            this._checkVoluntaryCancellation(messages);
            if (Odigeo.Utils.isMobile()) {
                this.hideTripStatusCard();
            }
        } else {
            this.loadNotifications(bookingData);
        }
    },

    _checkVoluntaryCancellation(messages) {
        if (messages.some(({
            cancellationType,
            type,
        }) => BIM_CANCELLATION_TYPE.VOLUNTARY === cancellationType && BIM_TYPE.CANCELLATION === type)) {
            this.preloadDownloadComponent(BIM_TYPE.CANCELLATION.toLowerCase());
        }
    },

    loadNotifications(bookingData, fromModification) {
        this.components.notifications.execute('load', bookingData, () => {
            if (!fromModification) {
                this.preloadDownloadComponent(BIM_TYPE.CANCELLATION.toLowerCase());
            }
        });
    },

    openBookingStatusInfo(labelStatus) {
        if (Odigeo.Utils.isMobile()) {
            trackingUtils.trackEvent('booking-status', `click_booking-status:${labelStatus}_pag:tripdetails`);
            Odigeo.Router.navigate('tripdetails_booking_status');
        }
    },

    openTheModificationFlow() {
        if (Odigeo.AB.getNewEntryPointsTripDetailsPartition === 2) {
            trackingUtils.trackEventWithCategory(`${TRACKING.TRIP_DETAILS_CATEGORY}_${Odigeo.SessionScope.flowProduct}`,
                'booking-status', 'confirmed-booking_click-cta:modify-trip_pag:tripdetails');
            this.navigateToNewMMB('modifyTrip');
        }
    },

    preloadDownloadComponent(notificationType) {
        const booking = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const bookingId = booking.bookingBasicInfo.id;
        const buyerMail = booking.buyer.mail;
        bookingInfoModel.destinationCity = getArrivalCity(booking);
        const bookingInfoData = manageMyBookingModule.getBookingInfo(bookingId, buyerMail);
        DownloadAppNotification.loadDownloadComponent(bookingInfoData, notificationType);
    },

    hideTripStatusCard() {
        $(this.$cachedSelectors.tripStatusCard).hide();
    },

    hideAncillaryCTA(type) {
        const selectorConfigByType = {
            bags: '.pax_details_open_add_bags',
            seats: '.pax_details_open_choose_seats',
        };
        const selectorByType = selectorConfigByType[type];
        if (selectorByType) {
            this.$el.find(selectorByType).addClass('odf-hidden');
        }
    },

    displayPostBookingSeatsOF2Wrapper() {
        this.$el.find(this.selectors.legacyPostBookingSeatsWrapper).addClass('odf-hidden');
        this.$el.find(this.selectors.postBookingSeatsWrapper).removeClass('odf-hidden');
    },

    showDiscountBubble(bookingId) {
        const widgetId = 'hotel-discount-bubble';
        return discountBubbleFactory.create({
            id: `${widgetId}`,
            el: this.$cachedSelectors.hotelDiscountBubble,
            bookingId,
        });
    },

    showDiscountBubbleMembership(bookingId) {
        const widgetId = 'hotel-discount-bubble';
        return discountBubbleFactoryMembership.create({
            id: `${widgetId}`,
            el: this.$cachedSelectors.hotelDiscountBubble,
            bookingId,
        });
    },

    _createBagsAndSeatsIfNeeded(transportType, bagsAndSeatsOrder) {
        if (transportType !== 'TRAIN') {
            this.components.bagsAndSeatsOffline = bagsAndSeatsOfflineFactory.create({
                el: this.$el.find('.bags_and_seats_offline'),
                widgetPosition: bagsAndSeatsOrder,
                model: this.model,
            });
            this.checkIfNewBagsPostBookingNeed(bagsAndSeatsOrder);
            this.checkIfNewSeatsPostBookingNeed(bagsAndSeatsOrder);
            this.createBoardingOptionsPOstBooking(bagsAndSeatsOrder);
        }
    },

    createBoardingOptionsPOstBooking(bagsAndSeatsOrder) {
        this.components.boardingOptionsPostBooking = ancillariesFactory.create({
            options: {
                child: boardingOptionsPostBookingFactory,
                childOptions: {
                    widgetPosition: bagsAndSeatsOrder,
                },
            },
            el: this.$el.find('.boarding_options_postbooking'),
        });
    },

    checkIfNewSeatsPostBookingNeed(bagsAndSeatsOrder) {
        const isNewSeatsPostBooking = Odigeo.AB.isEnhancedPostbookingSeatsMobile || Odigeo.AB.isEnhancedPostbookingSeatsDesktop;
        if (isNewSeatsPostBooking) {
            this.components.seatsPostBooking = ancillariesFactory.create({
                options: {
                    child: seatsPostBookingFactory,
                    childOptions: {
                        widgetPosition: bagsAndSeatsOrder,
                    },
                },
                el: this.$el.find('.seats_postbooking'),
            });
        }
    },

    checkIfNewBagsPostBookingNeed(bagsAndSeatsOrder) {
        const isNewBagsPostBooking = Odigeo.AB.isEnhancedPostbookingBagsMobile || Odigeo.AB.isEnhancedPostbookingBagsDesktop;
        if (isNewBagsPostBooking) {
            this.components.baggagePostBooking = ancillariesFactory.create({
                options: {
                    child: baggagePostBookingFactory,
                    childOptions: {
                        widgetPosition: bagsAndSeatsOrder,
                    },
                },
                el: this.$el.find('.baggage_postbooking'),
            });
        }
    },

    formatMin(totalMinutes) {
        const {days, hours, minutes} = Odigeo.Utils.getDurationUnits(totalMinutes);
        const {durationInMinutes, durationWithDays, durationShort} = this.keys;
        const cmsKeyArgs = [minutes];
        let translationTag = durationInMinutes;

        if (days > 0) {
            translationTag = durationWithDays;
            cmsKeyArgs.unshift(days, hours);
        } else if (hours > 0) {
            translationTag = durationShort;
            cmsKeyArgs.unshift(hours);
        }

        cmsKeyArgs.unshift(translationTag);
        return Odigeo.Utils.replaceCmsKeyArgs.apply(Odigeo.Utils.replaceCmsKeyArgs, cmsKeyArgs);
    },

    _loadMappings() {
        if (Odigeo._.isEmpty(this.model.countries)) {
            this.model.countries = getMappingList(Odigeo.UserArea.countries);
        }
    },

    _showGtBannerNoBookings() {
        moduleXSELLController.then(({default: controller}) => {
            const cont = controller();
            cont.createGtNoBookingsBanner(this.el);
        });
    },

    _goToTappedOneTrip(e) {
        e.preventDefault();
        const dataActions = $(e.currentTarget).data('actions');
        const bookingList = $(e.currentTarget).data('bookinglist');
        const trackingData = bookingList === 'pastTrips' ? 'past' : 'upcoming';
        const trackingAction = `${trackingData}_trips`;
        const booking = this.processTappedBookingInfo(e, Odigeo.AB.isBookingImportantMessage);
        const params = Odigeo._.isUndefined(dataActions) ? {} : {params: `actions=${dataActions}`};
        const OneTappedLabel = `view_${trackingData}-trip_${booking.myTripStatus.toLowerCase()}_details`;
        let label = Odigeo._.isUndefined(dataActions) ? OneTappedLabel : myTripsUtils.checkinMfTracking(booking, 'myTripsList');
        Odigeo.trigger(`${this.id}:onGoToTappedOneTripTracking`, booking, label, trackingAction);
        Odigeo.Router.navigate('tripdetails', params);
    },

    processTappedBookingInfo(e, hasForceReload, index) {
        const {userDTO} = this.model.get('myBookings');
        const _index = Odigeo._.isNull(index) || Odigeo._.isUndefined(index) ? $(e.currentTarget).data('index') : index;
        const bookingList = $(e.currentTarget).data('bookinglist');
        const bookingListDetail = bookingList === 'pastTrips' ? 'pastBookingDetail' : 'bookingDetail';
        const booking = userDTO[bookingListDetail][_index];
        this.storeBookingInfo(booking, hasForceReload);
        bookingInfoModel.destinationCity = getArrivalCity(booking);
        return booking;
    },

    storeBookingInfo(booking, hasForceReload) {
        tripDetailsStorageUtils.setInSessionWithExpirationTime(BOOKING_INFO_KEY, {
            ...booking,
            forceReload: hasForceReload,
        });
    },

    navigateSupportAreaHome(booking = {}) {
        Odigeo.Router.navigate(`sahome/${booking.tdToken || ''}`);
    },

    onClickToMmbBtn(e) {
        const {userDTO} = this.model.get('myBookings');
        e.preventDefault();
        const bookingListContent = $(e.currentTarget).parent().hasClass('od-bookingListContent') &&
            $(e.currentTarget).parent('.od-bookingListContent');
        const index = bookingListContent.data ? bookingListContent.data('index') : 0;
        const isPastBookingList = (bookingListContent.data && bookingListContent.data('bookinglist')) === 'pastTrips';
        const booking = userDTO[isPastBookingList ? 'pastBookingDetail': 'bookingDetail'][index];
        const bookingId = booking.bookingBasicInfo.id;

        trackMMBClickButton(bookingId, bookingListContent && bookingListContent.data ? 'mytrips':'tripdetails');
        trackClickEvent(e);
        this.navigateSupportAreaHome(booking);
    },
    _goToMmbPage({booking, index, e}) {
        const {mail, name, lastNames} = booking.buyer;
        const bookingId = booking.bookingBasicInfo.id;

        this.processTappedBookingInfo(e, null, index);
        const params = Odigeo._.isUndefined(bookingId) ? {} : {
            email: `${mail}`,
            bookingId: `${bookingId}`,
            name: `${name} ${lastNames}`,
            myTripStatus: booking.myTripStatus,
        };
        bookingInfoModel.mail = mail;
        bookingInfoModel.bookingId = bookingId;
        bookingInfoModel.destinationCity = getArrivalCity(booking);
        Odigeo.Router.navigate('managemybooking', {...params, params: `token=${bookingInfoModel.token}`});
    },

    toggleMMBLightbox(selector = 'newManageMyBooking') {
        const mmbLightboxSelector = this.selectors[`${selector}Lightbox`];
        const mmbLightbox = $(mmbLightboxSelector);
        mmbLightbox.toggleClass('open');
        const hasScroll = !mmbLightbox.hasClass('open');
        setPageScroll(hasScroll, mmbLightboxSelector);
    },

    toggleDownloadAppNotificationLightbox() {
        const downloadAppSelector = this.selectors.downloadAppNotification;
        $(downloadAppSelector).toggleClass('open');

        const isLightboxOpened = $(downloadAppSelector).hasClass('open');
        setPageScroll(!isLightboxOpened, downloadAppSelector);

        const flowProduct = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo')).accommodationBooking ? 'myardp' : 'myarfl';

        if (isLightboxOpened) {
            trackingUtils.trackEvent('trip_details', `manage_appsplash-onload_sel:see-refund_pag:${flowProduct}`, 'trip_details');
        } else {
            trackingUtils.trackEvent('trip_details', `manage_appsplash-click_sel:close_pag:${flowProduct}`, 'trip_details');
        }
    },

    _onManageMyBookingBtnClick(e) {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const {bookingBasicInfo: {id}} = bookingInfo;
        trackMMBClickButton(id, 'tripdetails');
        trackClickEvent(e);
        this.navigateSupportAreaHome(bookingInfo);
    },
    // New MMB desktop
    _onNewManageMyBookingTripDetailsClick(page) {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const selectedPage = typeof page === 'string' ? page : undefined;
        const {buyer: {mail}, bookingBasicInfo: {id}} = bookingInfo;
        bookingInfoModel.destinationCity = getArrivalCity(bookingInfo);

        trackMMBClickButton(id, 'tripdetails');
        this.loadMMB(id, mail, selectedPage);
        this.toggleMMBLightbox(selectedPage);
    },

    openNewAlternativesFlow() {
        this.navigateToNewMMB('alternatives');
    },

    _goToLink(e) {
        const link = $(e.currentTarget);
        const page = link.attr('data-ref');
        let place = link.attr('data-place');

        place = Odigeo._.isEmpty(place) ? '_self' : place;

        if (!Odigeo._.isEmpty(page)) {
            const category = link.attr('data-track-category');
            const action = link.attr('data-track-action');
            const label = link.attr('data-track-label');
            trackingUtils.trackEvent(action, label, category);
            if (place === '_blank') {
                window.open(page);
            } else {
                window.open(page, place, false);
            }
        }
    },

    _foldingDetails({currentTarget} = {}, className) {
        let label;
        const $folderDetails = $(currentTarget || className);

        label = $folderDetails.attr('data-tracking');
        $folderDetails.toggleClass('od-mytrips-last-border');
        $folderDetails.siblings('.trip_folded_details').toggleClass('hidden');
        $folderDetails.find('.ficon').toggleClass('hidden');

        if (!className && $folderDetails.hasClass('od-mytrips-last-border')) {
            trackEvent(TRACKING.TRIP_DETAILS_CATEGORY, 'trip_details', label);
        }
    },

    openBagsPopup() {
        const isNewBagsPostbooking = Odigeo.AB.isEnhancedPostbookingBagsMobile || Odigeo.AB.isEnhancedPostbookingBagsDesktop;
        if (isNewBagsPostbooking) {
            this.components.baggagePostBooking.execute('toggleChildLayer', true);
        } else {
            this.components.bagsAndSeatsOffline.execute('addBags');
        }
    },
    isOpened: false,
    openPopupStartup(product) {
        if (!this.isOpened) {
            if (product === 'bags') {
                this.openBagsPopup();
            }
            if (product === 'seats') {
                this.openSeatsPopup();
            }
            this.isOpened = true;
        }
    },
    openBagsAndSeatsPopup({product}) {
        if (product === 'bags') {
            this.openBagsPopup();
        }
        if (product === 'seats') {
            this.openSeatsPopup();
        }
    },
    openSeatsPopup() {
        const isNewSeatsPostbooking = Odigeo.AB.isEnhancedPostbookingSeatsMobile || Odigeo.AB.isEnhancedPostbookingSeatsDesktop;

        if (isNewSeatsPostbooking) {
            this.components.seatsPostBooking.execute('toggleChildLayer', true);
        } else {
            this.components.bagsAndSeatsOffline.execute('chooseSeats');
        }
    },

    showManageMyBookingBox(hasRedirection, page, autoChange, autoCancel) {
        Odigeo.SessionScope.mmbFrom = 'sahome';
        this._showManageMyBookingButton(this._getContainerForManageMyBooking());
        if (hasRedirection) {
            this.navigateToNewMMB(page, autoChange, autoCancel);
        }
    },
    openMmbOf1() {
        Odigeo.SessionScope.mmbFrom = 'tripdetails';
        this.navigateToNewMMB('modifyTrip');
    },
    openMmbOf2() {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        if (Odigeo.Utils.isDesktop()) {
            const {bookingBasicInfo: {id}} = bookingInfo;
            trackMMBClickButton(id, 'tripdetails');
        }
        this.navigateSupportAreaHome(bookingInfo);
    },
    navigateToNewMMB(page, autoChange, autoCancel) {
        const bookingInfo = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const isNewCancellationFlow = page === 'cancellationHSA' && Odigeo.AB.isHsaNewCancellationFlowEnabled;
        bookingInfoModel.mail = bookingInfo.buyer.mail;
        bookingInfoModel.bookingId = bookingInfo.bookingBasicInfo.id;
        bookingInfoModel.name = `${bookingInfo.buyer.name} ${bookingInfo.buyer.lastNames}`;
        bookingInfoModel.destinationCity = getArrivalCity(bookingInfo);
        const autoChangeParam = autoChange ? `;autoChange=${autoChange}` : '';
        const autoCancelParam = autoCancel ? `;autoCancel=${autoCancel}` : '';

        if (Odigeo.Utils.isDesktop() && !isNewCancellationFlow) {
            if (Odigeo.AB.isSplitMMBFromTripdetails) {
                Odigeo.Router.navigate('tripdetails_booking_management', {
                    params: `td=${bookingInfo.tdToken}${autoChangeParam}${autoCancelParam};actions=openmmb;funnel=${page}`,
                });
            } else {
                this._onNewManageMyBookingTripDetailsClick(page);
            }
        } else if (Odigeo.Device.navigator.isNative() || !isNewCancellationFlow) {
            const {token} = bookingInfoModel;
            const selectedPageParam = page ? `;selectedPage=${page}` : '';
            window.history.pushState({}, document.title, window.location.href.replace('actions=openmmb', ''));
            Odigeo.Router.navigate('managemybooking', {
                params: `token=${token}${autoChangeParam}${autoCancelParam}${selectedPageParam}`,
            });
        }
    },

    navigateToMMBCancellationsHSA() {
        this.navigateToNewMMB('cancellationHSA');
    },

    _getContainerForManageMyBooking() {
        return this.$cachedSelectors.manageMyBookingContainer;
    },

    // Tripdetails page MMB button click
    _showManageMyBookingButton($container) {
        const manageMyBookingBtn = $container.find('.manage_my_booking_btn');
        manageMyBookingBtn.off().on(Odigeo.Events.tap, Odigeo._.bind(this._onManageMyBookingBtnClick, this));
        trackJQElementDisplayed(Odigeo.Utils.isDesktop() ? manageMyBookingBtn : $container.find('.goToMmbPage'));
        $container.removeClass(CSS_CLASSES.ODF_HIDDEN);
    },

    openLightBoxMsg(data) {
        const msg = this.model.popUpErrors[data];
        this.$cachedSelectors[msg].toggleClass('opened open');
    },

    closeLightBox(e) {
        const lightbox = $(e.target).hasClass('opened open') ? $(e.target) : $(e.target).parents('.opened');
        lightbox.removeClass('opened open');
    },

    updateUserName(userName) {
        this.changeTitleInLightBox(this.$cachedSelectors.deepTokenKoLightbox,
            Odigeo.Utils.replaceCmsKeyArgs(this.keys.deepTokenLightboxTitle, userName));
        this.changeTitleInLightBox(this.$cachedSelectors.deepTokenNotOwnerLightbox,
            Odigeo.Utils.replaceCmsKeyArgs(this.keys.deepTokenLightboxTitleNotOwner, userName));
    },

    changeTitleInLightBox($lightBox, title) {
        $lightBox.find('.deep_token_lightbox_title').text(title);
    },

    toggleWaitingPageVisibility(isOpened) {
        this.$cachedSelectors.myTripsWaiting.toggleClass(CSS_CLASSES.OPEN_OPENED, isOpened);
        if (!isOpened) {
            Odigeo.UIElements.enhanceLoading($('.waiting_page')).hideLoading();
        }
    },

    /* Tripdetails & SMT */
    toggleIntermediateLayerVisibility(isVisible) {
        if (Odigeo.Utils.isDesktop()) {
            $('.intermediate_layer_lightbox').toggleClass('open', isVisible);
        }
        $('#openmytrips').toggleClass('od-intermediate-layer-opened', isVisible);
        if (isVisible) {
            trackingUtils.trackPage(TRACKING.INTERMEDIATE_LAYER_PAGE, {funnel: false});
        }
    },

    makeProductTabVisible(product, action) {
        const PRODUCT_TO_KEYWORD_MAP = {
            flightSummary: this.model.TAB_CONTENT_KEYWORDS.FLIGHT_SUMMARY,
            checkIn: this.model.TAB_CONTENT_KEYWORDS.CHECK_IN,
            hotels: this.model.TAB_CONTENT_KEYWORDS.HOTELS,
            default: this.model.TAB_CONTENT_KEYWORDS.OFFERS_AND_DISCOUNTS,
        };
        const SECTION_ACTION = {
            scrollPax: '.pax_details_baggage_info',
        };
        const contentKeyword =
            PRODUCT_TO_KEYWORD_MAP[product] ||
            PRODUCT_TO_KEYWORD_MAP.default;
        const section = SECTION_ACTION[action];
        if (contentKeyword) {
            this._forceTabByContentKeyword(contentKeyword);
        }
        this.scrollToSection(section);
    },

    makeCollapsibleSectionVisible(action) {
        const SECTION_ACTION = {
            scrollPax: '.passenger_baggage_info',
        };
        const section = SECTION_ACTION[action];
        if (section) {
            this._foldingDetails(undefined, section);
            this.scrollToSection(section);
        }
    },

    scrollToSection(section) {
        if (section) {
            setTimeout(() => {
                Odigeo.Utils.scrollToElement(this.$el.find(section));
            }, 1000);
        }
    },

    tabSelection(event) {
        const $targetTabSelector = $(event.currentTarget);
        const targetContentKeyword = getContentKeyword($targetTabSelector);
        this._trackTabSelectionEvent(targetContentKeyword);
        if (!hasSameContentKeyword($targetTabSelector, ...this._get$activeTabSelectors())) {
            this._performTabChange($targetTabSelector);
        }
        Odigeo.trigger('my-trips:selectedTab', targetContentKeyword);
    },

    addCheckinClassToContainer(className) {
        this.$cachedSelectors.myTripsBookingDetails.addClass(className);
    },

    setTripCardCheckInButtonVisibility(shouldBeHidden) {
        this.$cachedSelectors.tripCardCheckInButton.toggleClass(CSS_CLASSES.ODF_HIDDEN, shouldBeHidden);
    },

    addCheckinPillRequest() {
        this.$cachedSelectors.checkinPillRequest.addClass('open');
    },

    openRetryLink() {
        this.checkin.execute('openCheckinProviderFormStep');
    },

    setIsPrimeUser(isPrimeUser) {
        this.model.set('isPrimeUser', isPrimeUser);
    },
    getIsPrimeUser() {
        return this.model.get('isPrimeUser');
    },

    setPrimeExpirationDate(primeExpirationDate) {
        this.model.set('primeExpirationDate', primeExpirationDate);
    },

    getPrimeExpirationDate() {
        return this.model.get('primeExpirationDate');
    },

    _trackTabSelectionEvent(contentKeyword) {
        const {myTripStatus = ''} = Odigeo.Utils.parseJson(Odigeo.Session.get('bookingInfo'));
        const label = `view_trip_${myTripStatus.toLowerCase()}_tab_${contentKeyword}`;
        trackEvent(TRACKING.TRIP_DETAILS_CATEGORY, TRACKING.UPCOMING_TRIPS_ACTION, label);
    },

    _forceTabByContentKeyword(contentKeyword) {
        const $targetTabSelector = this._get$tabSelectorByContentKeyword(contentKeyword);
        if ($targetTabSelector && !hasSameContentKeyword($targetTabSelector, ...this._get$activeTabSelectors())) {
            this._performTabChange($targetTabSelector);
        }
    },

    _get$tabSelectorByContentKeyword(keyword) {
        const querySelector = `.${CSS_CLASSES.TABS.TAB_SELECTOR}[data-content-keyword="${keyword}"]`;
        return get$ElementsInElement(this.$cachedSelectors.tabSelectorsContainer, querySelector)[0];
    },

    _get$activeTabSelectors() {
        return get$ElementsInElement(
            this.$cachedSelectors.tabSelectorsContainer,
            `.${CSS_CLASSES.TABS.TAB_SELECTOR}.${CSS_CLASSES.ACTIVE}`
        );
    },

    _get$tabContentElements() {
        return get$ElementsInElement(this.$cachedSelectors.tabsContentWrapper, `.${CSS_CLASSES.TABS.TAB_CONTENT}`);
    },

    _performTabChange($targetTab) {
        const targetContentKeyword = getContentKeyword($targetTab);
        Odigeo._.get(this.tabsController[targetContentKeyword], 'setActiveCallback', Odigeo._.noop).call();
        this._get$activeTabSelectors().map(($el) => $el.removeClass(CSS_CLASSES.ACTIVE));
        $targetTab.addClass(CSS_CLASSES.ACTIVE);
        this._get$tabContentElements()
            .map(($el) => $el.toggleClass(CSS_CLASSES.ODF_HIDDEN, getContentKeyword($el) !== targetContentKeyword));
        if (targetContentKeyword === 'checkIn') {
            $('.tripdetails_footer_of2').addClass('odf-hidden');
        } else {
            $('.tripdetails_footer_of2').removeClass('odf-hidden');
        }
    },

    // Mytrips page MMB button click
    onManageMyBookingListBtn(e) {
        const bookingId = $(e.currentTarget).data('bookingid');
        const booking = this.processTappedBookingInfo(e);
        trackMMBClickButton(bookingId, 'mytrips');
        trackClickEvent(e);
        this.navigateSupportAreaHome(booking);
    },

    onTapTripsListTab(e) {
        if ($(e.currentTarget).attr('data-tripstab') === 'past') {
            this._showTripList('pastListBookings', 'past', this.$cachedSelectors.myTripsPastTab);
        } else {
            this._showTripList('listBookings', 'upcoming', this.$cachedSelectors.myTripsUpcomingTab);
        }
    },

    _showTripList(tripList, partialLabel, element) {
        const {userDTO} = this.model.get('myBookings');
        const hasUpcomingBookings = userDTO.bookingDetail.length > 0;
        const stateAttr = (tripList === 'listBookings') && !hasUpcomingBookings ? 'noBookings' : tripList;
        this.$cachedSelectors.myTripsBody.attr('data-state', stateAttr);
        this.$cachedSelectors.myTripsListNavTab.removeClass(getTripsActiveClass());
        element.toggleClass(getTripsActiveClass());
        trackEvent(TRACKING.MY_TRIPS_CATEGORY, 'tab_trips', `view_trip_${partialLabel}_tab`);
    },

    // Mytrips page, old MMB
    goToManageMyBookingPage(data) {
        const tokenParam = data.token ? `?mb=${data.token}` : '';
        this.manageBookingWindow.location = `${this.keys.myTripManageMyBookingButtonUrl}${tokenParam}`;
    },

    getBookingDetailsForMyTripsItineraryStatusTracking() {
        const {userDTO} = this.model.get('myBookings');
        return userDTO.bookingDetail.filter((booking) => booking.myTripStatus === 'ALTERED');
    },

    hideFlightStatusMessage() {
        this.$cachedSelectors.flightStatusMessage.toggleClass(CSS_CLASSES.ODF_HIDDEN, true);
    },

    showFlightStatusMessage() {
        this.$cachedSelectors.flightStatusMessage.toggleClass(CSS_CLASSES.ODF_HIDDEN, false);
    },

    onShowHotels() {
        if (Odigeo.Utils.isDesktop()) {
            Odigeo.Utils.scrollToElement(this.$cachedSelectors.hotelWidget);
            trackShowHotelClick(getBookingId());
        }
    },

    showMembershipHotelBanner() {
        this.components.membershipHotelBanner = membershipHotelBanner.factory.create({
            id: MEMBERSHIP_HOTEL_BANNER,
        });
        trackWidgetOnLoad();
    },

    hasToShowMembershipHotelBanner({accommodationBooking, shouldHideAllProductOffers}) {
        const hasHotelBooked = !Odigeo._.isEmpty(accommodationBooking);
        const xsIframeWillRender = !shouldHideAllProductOffers && Odigeo.CrossSelling.isHotelsActive && !hasHotelBooked && !Odigeo.Utils.isMobile();
        return isPrimeConditionsHotel() && xsIframeWillRender;
    },

    // TODO: Is not necessary in isBookingImportantMessage
    updateItineraryScheduleChanges(scheduleChangesPNRs, cancelledPNRs) {
        this.components.bookingItinerary.execute('updateItineraryScheduleChanges', {
            scheduleChangesPNRs,
            cancelledPNRs,
        });
    },

    // TODO: Is not necessary in isBookingImportantMessage
    showSegmentsItineraryBox() {
        this.components.bookingItinerary.execute('showSegmentsItineraryBox');
    },

    focusCheckinTab() {
        this.$cachedSelectors.checkinTabBadge.removeClass(CSS_CLASSES.ODF_HIDDEN);
        this._forceTabByContentKeyword(this.model.TAB_CONTENT_KEYWORDS.CHECK_IN);
    },

    showCheckinTab() {
        const checkinTab = this._get$tabSelectorByContentKeyword(this.model.TAB_CONTENT_KEYWORDS.CHECK_IN);
        if (checkinTab) {
            checkinTab.removeClass(CSS_CLASSES.ODF_HIDDEN);
        }
    },
    loadCheckinScenario(scenario) {
        this.checkinModule.loadCheckinScenario(scenario);
    },
    _confirmationBackup() {
        this.$cachedSelectors.myTripsBookingDetails.empty()
            .append(this.templates.confirmationBackup());
        this.toggleWaitingPageVisibility(false);
        this.$cachedSelectors.myTripsBody.attr('data-state', 'bookingDetails');
    },
    _createAppBanner(bookingData) {
        const id = 'download-app-banner';
        this.components.appTouchPoint = downloadAppBannerFactory.create({
            id,
            options: {
                bookingData,
            },
        });
    },
    showBagsAndSeatsMoreInfoLink(bagsAndSeatsLoaded) {
        const parent = this.$el.find('.ancillaries_postbooking_container');
        if (bagsAndSeatsLoaded.bags.showLink && bagsAndSeatsLoaded.seats.showLink) {
            parent.find('[data-type="bags"]').removeClass('odf-hidden');
            parent.find('[data-type="seats"]').removeClass('odf-hidden');
        }
    },
})));
